import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=681fb606"
import script from "./DashboardWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=681fb606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports